import { getArgsAsTypesafeObjectProperties } from '../constants-util';
export const constants = getArgsAsTypesafeObjectProperties('GET_DEBTOR_IMAGE', 'GET_DEBTOR');
